import React from 'react';
import TableHead from './TableHead';
import TableBody from './TableBody';

const Table: React.FC = () => {
  return (
    <table className="datatables-users table dataTable no-footer dtr-column">
      <TableHead />
      <TableBody />
    </table>
  );
};

export default Table;
